module.exports = __webpack_public_path__ + "static/img/instoreBanner_m.7c148c0f.png";